/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Technologies_OfficialInputs */

const en_us2_technologies_official = /** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Official site`)
};

const es_es2_technologies_official = /** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitio oficial`)
};

const ru_technologies_official = /** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Официальный сайт`)
};

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const id_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const ms_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const da_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const de_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const es_mx2_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const fil_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const fr_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const it_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const hu_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const nl_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const no_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const pl_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const pt_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const pt_br2_technologies_official = pt_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const ro_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const fi_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const sv_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const vi_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const tr_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const cs_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const bg_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const uk_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const ar_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const hi_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const th_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const ja_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const zh_cn2_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const zh_hant1_technologies_official = en_us2_technologies_official;

/** @type {(inputs: Technologies_OfficialInputs) => LocalizedString} */
const ko_technologies_official = en_us2_technologies_official;

/**
* | output |
* | --- |
* | "Official site" |
*
* @param {Technologies_OfficialInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const technologies_official = /** @type {((inputs?: Technologies_OfficialInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Technologies_OfficialInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_technologies_official(inputs)
	if (locale === "ms") return ms_technologies_official(inputs)
	if (locale === "da") return da_technologies_official(inputs)
	if (locale === "de") return de_technologies_official(inputs)
	if (locale === "en-US") return en_us2_technologies_official(inputs)
	if (locale === "es-ES") return es_es2_technologies_official(inputs)
	if (locale === "es-MX") return es_mx2_technologies_official(inputs)
	if (locale === "fil") return fil_technologies_official(inputs)
	if (locale === "fr") return fr_technologies_official(inputs)
	if (locale === "it") return it_technologies_official(inputs)
	if (locale === "hu") return hu_technologies_official(inputs)
	if (locale === "nl") return nl_technologies_official(inputs)
	if (locale === "no") return no_technologies_official(inputs)
	if (locale === "pl") return pl_technologies_official(inputs)
	if (locale === "pt-BR") return pt_br2_technologies_official(inputs)
	if (locale === "pt") return pt_technologies_official(inputs)
	if (locale === "ro") return ro_technologies_official(inputs)
	if (locale === "fi") return fi_technologies_official(inputs)
	if (locale === "sv") return sv_technologies_official(inputs)
	if (locale === "vi") return vi_technologies_official(inputs)
	if (locale === "tr") return tr_technologies_official(inputs)
	if (locale === "cs") return cs_technologies_official(inputs)
	if (locale === "bg") return bg_technologies_official(inputs)
	if (locale === "ru") return ru_technologies_official(inputs)
	if (locale === "uk") return uk_technologies_official(inputs)
	if (locale === "ar") return ar_technologies_official(inputs)
	if (locale === "hi") return hi_technologies_official(inputs)
	if (locale === "th") return th_technologies_official(inputs)
	if (locale === "ja") return ja_technologies_official(inputs)
	if (locale === "zh-CN") return zh_cn2_technologies_official(inputs)
	if (locale === "zh-Hant") return zh_hant1_technologies_official(inputs)
	return ko_technologies_official(inputs)
});
export { technologies_official as "technologies.official" }